module.exports = __webpack_public_path__ + "img/krathong-item18.190e6d0e.png";